import { InfoItem, Text } from '@intellecteu/common-ui';
import { KMS_DRIVER_OPTIONS, Labels } from 'app/constants';
import { formatBooleanForDetailsPage, resolveKmsDriver } from 'app/utils';

/** HOCON-style values often arrive as `{ type = "aws", ... }`; show inner text without braces. */
const formatKmsValueForDisplay = (raw: string): string => {
  const t = raw.trim();
  return t.startsWith('{') && t.endsWith('}') ? t.slice(1, -1).trim() : t;
};

export interface KmsDetails {
  enableKms?: boolean;
  kmsValue?: string;
  kmsServiceAccount?: string;
  kmsAzureVaultSecretName?: string;
  overrideImage?: string;
}

const isPresent = (v?: string): v is string => v != null && v !== '';

export const KmsDetailsList = ({
  enableKms,
  kmsValue,
  kmsServiceAccount,
  kmsAzureVaultSecretName,
  overrideImage,
  columnClassName,
}: KmsDetails & { columnClassName?: string }) => {
  if (enableKms !== true) {
    return <InfoItem label={Labels.ENABLE_KMS} value={formatBooleanForDetailsPage(false)} />;
  }

  const kmsDriver = resolveKmsDriver({ kmsAzureVaultSecretName, kmsValue });

  return (
    <>
      <InfoItem label={Labels.ENABLE_KMS} value={formatBooleanForDetailsPage(true)} />
      <InfoItem
        label={Labels.KMS_DRIVER}
        value={KMS_DRIVER_OPTIONS.find((option) => option.value === kmsDriver)?.label ?? kmsDriver}
      />

      {isPresent(kmsServiceAccount) && (
        <InfoItem
          label={Labels.KMS_SERVICE_ACCOUNT}
          value={kmsServiceAccount}
          copyValue={kmsServiceAccount}
          className={columnClassName}
          textMaxWidth={240}
          withTruncation
          isCopy
        />
      )}
      {isPresent(kmsValue) && (
        <InfoItem
          label={Labels.KMS_VALUE}
          value={formatKmsValueForDisplay(kmsValue)}
          copyValue={kmsValue}
          className={columnClassName}
          valueSize={Text.size.xs}
          textMaxWidth={240}
          withTruncation
          isCopy
        />
      )}
      {isPresent(kmsAzureVaultSecretName) && (
        <InfoItem
          label={Labels.KMS_AZURE_VAULT_SECRET_NAME}
          value={kmsAzureVaultSecretName}
          copyValue={kmsAzureVaultSecretName}
          className={columnClassName}
          textMaxWidth={240}
          withTruncation
          isCopy
        />
      )}
      {isPresent(overrideImage) && (
        <InfoItem
          label={Labels.PARTICIPANT_IMAGE_OVERRIDE}
          value={overrideImage}
          copyValue={overrideImage}
          className={columnClassName}
          textMaxWidth={240}
          withTruncation
          isCopy
        />
      )}
    </>
  );
};
